import React, { FC } from 'react';

import Schema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { Typography } from '@mui/material';
import { useApplication } from '../../../../../../context/ApplicationContext';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { concat } from 'lodash';
const P = Schema.attributes;
const BerichtEvaluation: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<Typography variant="h3">Bericht und Evaluation</Typography>

			<CreateForm
				formStruc={StrucBericht()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default BerichtEvaluation;

export const StrucBericht = () => {
	return [
		{
			fields: [P.Bericht_Und_Evaluation_Sachbericht_Kurzfassung, P.Bericht_Und_Evaluation_Projektevaluation],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

export const GetBerichtEvaluationFormStruc = () => {
	return concat(StrucBericht());
};
